<template>
	<div class="content-detail-v">
		<div class="title-wrapper">
			<div class="title inline-column-left">
				<img class="bg" src="~@/assets/png/content-title-icon.png" />
				<div class="txt" v-if="curData">
					<template v-if="curData.tag1">{{curData.tag1}}<span>·</span></template>
					<template v-if="curData.tag2">{{curData.tag2}}<span>·</span></template>
					{{curData.title}}</div>
			</div>
		</div>
		<div class="auto-height" v-if="curData">
			<div class="content calc-line" v-html="curData.content"></div>
		</div>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'ContentDetailV',
		mixins: [IndexMixin],
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.content-detail-v {
		width: 100%;
		padding: 0 calc(52px * var(--scale-rate));
		position: relative;
		
		.title-wrapper {
			width: 100%;
			height: calc(128px * var(--scale-rate));
			position: relative;
			margin-top: calc(15px * var(--scale-rate));
		}
		.title {
			position: absolute;
			top: 0;
			left: 0;
			width: calc(100% / var(--scale-rate));
			height: 128px;
			transform: scale(var(--scale-rate));
			transform-origin: left top;
			padding-left: 36px;
			padding-top: 5px;
			
			.txt {
				font-size: 36px;
				color: rgb(96, 96, 96);
				span {
					padding: 0 15px;
				}
			}
			.bg {
				position: absolute;
				left: 12px;
				top: 0;
				width: 117px;
				height: 128px;
			}
		}
		.auto-height {
			width: 100%;
		}
		.content {
			margin-top: calc(38px * var(--scale-rate));
			//border: 1px solid #000000;
			width: calc(100% / var(--scale-rate));
			overflow-y: auto;
			overflow-x: hidden;
			transform: scale(var(--scale-rate));
			transform-origin: left top;
		}
	}
</style>